const API_ENVIRONMENTS = [
  {
    label: 'test',
    apiHost: 'https://cdn.test.luxuryescapes.com',
    notes: 'Use for test-admin, local admin configured against test, and test content editing.',
  },
  {
    label: 'prod',
    apiHost: 'https://api.luxuryescapes.com',
    notes: 'Use for production Admin Portal content editing.',
  },
];

export function getApiEnvironmentTable() {
  return API_ENVIRONMENTS.map(({ label, apiHost, notes }) => `| ${label} | \`${apiHost}\` | ${notes} |`).join('\n');
}
